<template>
    <div>
        <v-layout wrap vuetify-grid>
            <v-flex xs12 sm6 sm-side-padding>
                <v-menu
                    v-model="menuFrom"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                >
                    <v-text-field
                        slot="activator"
                        v-model="dateFrom"
                        label="Date From"
                        readonly
                        solo
                        clearable
                    />
                    <v-date-picker v-model="dateFrom" @input="updateCalendar($event, 'menuFrom')" />
                </v-menu>
            </v-flex>

            <v-flex xs12 sm6 sm-side-padding>
                <v-menu
                    v-model="menuTo"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                >
                    <v-text-field
                        slot="activator"
                        v-model="dateTo"
                        label="Date to"
                        readonly
                        solo
                        clearable
                    />
                    <v-date-picker v-model="dateTo" @input="updateCalendar($event, 'menuTo')" />
                </v-menu>
            </v-flex>
        </v-layout>
        <div class=" sm-side-padding">  
            <table id="ActivityLogTable" class="table " style="width:100%" />
        </div>
    </div>
</template>

<script>
export default {

    name: "AdvanceLogTable",

    data () {
        return {
            dateFrom: null,
            dateFromFormatted: null,
            menuFrom: false,

            dateTo: null,
            dateToFormatted: null,
            menuTo: false,
        };
    },
    watch: {
		  dateFrom() {
		    this.dateFromFormatted = null;
		    if (this.dateFrom) {
		      this.dateFromFormatted = moment(this.dateFrom).local().format();
		    }
		    this.redrawTable();
		  },
		  dateTo() {
		    this.dateToFormatted = null;
		    if (this.dateTo) {
		      this.dateToFormatted = moment(this.dateTo).local().format();
		    }
		    this.redrawTable();
		  }
    },
    mounted() {
        var date = new Date();
        var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        this.dateFromFormatted = moment(firstDay).local().format();
        this.dateToFormatted = moment(lastDay).local().format();

        this.dateFrom = moment(firstDay).format("YYYY-MM-DD");
        this.dateTo = moment(lastDay).format("YYYY-MM-DD");

        this.drawTable();
    },
    methods: {
        drawTable() {
            var self = this;
            $("#ActivityLogTable").DataTable(dataTableOption({
                "ajax": {
                    "url": "AuditLog/GetAuditLogs",
                },
                data: {
                    StartDate: this.dateFromFormatted,
                    EndDate: this.dateToFormatted 
                },
                "order": [[ 0, "desc" ]],
                "columnDefs": [
                    { targets: "_all", defaultContent: "-" },
                ],
                "columns": [
                    { data: "id", title: "ID" },
                    { data: "methodName", title: "Method Name" },
			        { data: "serviceName", title: "Service Name" },
			        { data: "userName", title: "User Name" },
			        { data: "userId", title: "User Id" },
                    { data: "browserInfo", title: "Browser Info" },
                    { data: "clientIpAddress", title: "Client Ip Address" },
                    { data: "clientName", title: "Client Name" },
                    { data: "customData", title: "Custom Data" },
                    { data: "impersonatorUserId", title: "Impersonator User Id" },
                    { data: "impersonatorTenantId", title: "Impersonator Tenant Id" },
                    { data: "executionDuration", title: "Execution Duration" },
                    { data: "exception", title: "Exception" },
		            // { data: 'parameters', title: 'Parameters' },
			        { data: "executionTime", title: "ExecutionTime", render: function(date) { return moment(date).local().format("ll LTS"); } },
		          ],
		          "exportTitle": "Advance Log Table",
			      }));
        },
        updateCalendar(date, menuType) {
            this[menuType] = false;
        },
        redrawTable() {
            if ($.fn.DataTable.isDataTable("#ActivityLogTable")) {   
                $("#ActivityLogTable").DataTable().destroy();
                $("#ActivityLogTable").empty();
                this.drawTable();
            }
        },
    }
};
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/components/UMS/AuditLog/AdvanceLogTable.vue